module.exports = __webpack_public_path__ + "static/trees-0b8a7f53396e3ab7126af93f6f131170.svg";